import { render, staticRenderFns } from "./StatusChild.vue?vue&type=template&id=23f27cd4&scoped=true&"
import script from "./StatusChild.vue?vue&type=script&lang=js&"
export * from "./StatusChild.vue?vue&type=script&lang=js&"
import style0 from "./StatusChild.vue?vue&type=style&index=0&id=23f27cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f27cd4",
  null
  
)

export default component.exports